import { useQueryClient } from '@tanstack/react-query';
import { JupiterClientEnvironment } from 'constants/Chat.constants';
import { setClientEnv } from 'ducks/chatPanel/chatPanelSlice';

import { resetChat } from 'actions';
import type { ProjectWithTokenExceeded } from 'api/types';
import { getProjectQueryKey } from 'utils/query';
import { useLocalDispatch } from './reduxHooks';
import useProjectRoute from './useProjectRoute';

export const useDraft = () => {
  const dispatch = useLocalDispatch();

  const queryClient = useQueryClient();

  const { accountId, projectId } = useProjectRoute();

  const setProjectIsDraft = () => {
    queryClient.setQueryData(
      getProjectQueryKey(accountId, projectId),
      (data: ProjectWithTokenExceeded | undefined) => {
        if (!data) {
          return;
        }
        return { ...data, is_draft: true };
      },
    );
  };

  const onProjectUpdate = () => {
    setProjectIsDraft();

    // get token limit status
    queryClient
      .invalidateQueries(getProjectQueryKey(accountId, projectId))
      .catch(e =>
        console.error('Error occurred. Could not invalidate queries', e),
      );

    dispatch(resetChat({ clientEnv: JupiterClientEnvironment.DRAFT }));
    dispatch(setClientEnv(JupiterClientEnvironment.DRAFT));
  };

  return {
    onProjectUpdate,
  };
};
